import { useMemo } from 'react';
import { DateTimeService, useAppClockService, useTimezone } from '@mews/framework';
import { getAppDateTimeNow } from '@mews-commander/utils';
import { FilterValueKey } from './types';

export const useCommonDefaultFilterValues = () => {
    const appClockService = useAppClockService();
    const timezone = useTimezone();

    return useMemo(() => {
        const now = getAppDateTimeNow({ appClockService, timezone });
        const tomorrow = DateTimeService.addDays(now, +1);

        const startDateTime = DateTimeService.startOfDay(now);
        const endDateTime = DateTimeService.startOfDay(tomorrow);

        const startUtc = DateTimeService.toUtc(startDateTime).value;
        const endUtc = DateTimeService.toUtc(endDateTime).value;

        return {
            [FilterValueKey.startDate]: startUtc,
            [FilterValueKey.endDate]: endUtc,
        };
    }, [appClockService, timezone]);
};
